import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: 'Please wait',
  description: 'We are loading something for you',
});
